<template>
  <div>
    <div>
    <b-nav class="main-nav">
    <b-nav-item class="logo">
    <img src="../assets/img/logo.png"/>
    </b-nav-item>
    </b-nav>
    </div>
    <div>
    <div class="main-div">
    <div class="login-div">
    <div class="profile-div col-11">
      <h5 class="mt-3 mb-3"> Privacy Policy </h5><br>
      <p>
        <h6><b>BACKGROUND:</b></h6> <br>
        Facit Data Systems Ltd understands that your privacy is important to you and that you care
        about how your personal data is used and shared online. We respect and value the privacy of
        everyone who visits this website, http://facitdatasystems.com Facit Data Systems Ltd (“Our Site”)
        and will only collect and use personal data in ways that are described here, and in a manner
        that is consistent with Our obligations and your rights under the law. <br><br>
        Please read this Privacy Policy carefully and ensure that you understand it. Your acceptance
        of Our Privacy Policy is deemed to occur upon your first use of Our
        Site AND You will be required
        to read and accept this Privacy Policy when signing up for an Account.
        If you do not accept and
        agree with this Privacy Policy, you must stop using Our Site immediately. <br><br>
        <h6><b>1. Definitions and Interpretation</b></h6> <br>
        In this Policy, the following terms shall have the following meanings: <br><br>
        <table border="1px" width="100%">
          <tr>
            <td width="20%">“Account”</td>
            <td>means an account required to access and/or use certain areas
              and features of Our Site;</td>
          </tr>
          <tr>
            <td>“Cookie”</td>
            <td>means a small text file placed on your computer or device by
              Our Site when you visit
              certain parts of Our Site and/or when you use certain features
              of Our Site. Details of
              the Cookies used by Our Site are set out in section 13, below;</td>
          </tr>
          <tr>
            <td>“Cookie Law”</td>
            <td>means the relevant parts of the Privacy and Electronic Communications
              (EC Directive) Regulations 2003;</td>
          </tr>
          <tr>
            <td>“personal data”</td>
            <td>means any and all data that relates to an identifiable person who can be directly or
              indirectly identified from that data. In this case,
              it means personal data that you give
              to Us via Our Site. This definition shall,
              where applicable, incorporate the definitions
              provided in the EU Regulation 2016/679 – the General Data Protection
              Regulation (“GDPR”); and</td>
          </tr>
          <tr>
            <td>“We/Us/Our”</td>
            <td>means Facit Data Systems Ltd, a limited company registered in England
              under company number 09090054,
              whose registered address is Atlantic House, 8 Bell Lane, Bellbrook
              Industrial Estate, Uckfield,
              East Sussex, TN22 1QL.</td>
          </tr>
        </table><br>
          <h6><b>2. Information About Us</b></h6> <br>
          1.1 Our Site is owned and operated by Facit Data Systems Ltd,
          a limited company registered in
          England under company number 0909054,
          whose registered address is Atlantic House, 8 Bell Lane,
          Bellbrook Industrial Estate, Uckfield, East Sussex, TN22 1QL. <br><br>
          1.2 Our VAT number is GB192 4162 10 <br><br>
          1.3 Our Data Protection Officer is W Hassan, and can be contacted by
          email at w.hassan@facitdatasystems.com,
          by telephone on 03700 610 498, or by post at Technology Centre,
          Whittington Hall, Whittington Road,
          Worcester, WR5 2ZW. <br><br>
          <h6><b>3. Definitions and Interpretation</b></h6> <br>
          This Privacy Policy applies only to your use of Our Site. Our Site may
          contain links to other websites.
          Please note that We have no control over how your data is collected, stored,
          or used by other websites
          and We advise you to check the privacy policies of any such
          websites before providing any data to them.<br><br>
          <h6><b>4. Your Rights</b></h6><br>
4.1 As a data subject, you have the following rights under the GDPR,
which this Policy and Our use of personal data have been designed to uphold:<br>&nbsp;
4.1.1 The right to be informed about Our collection and use of personal data;<br>&nbsp;
4.1.2 The right of access to the personal data We hold about you (see section 12);<br>&nbsp;
4.1.3 The right to rectification if any personal data We hold about you is
inaccurate or incomplete (please contact Us using the details in section 14);<br>&nbsp;
4.1.4 The right to be forgotten – i.e. the right to ask Us to delete any
personal data We hold about you (We only hold your personal data for a
limited time, as explained in section 6 but if you would like Us to delete
it sooner, please contact Us using the details in section 14);<br>&nbsp;
4.1.5 The right to restrict (i.e. prevent) the processing of your personal data;<br>&nbsp;
4.1.6 The right to data portability (obtaining a copy of your personal data
to re-use with another service or organisation);<br>&nbsp;
4.1.7 The right to object to Us using your personal data for particular purposes;  and <br>&nbsp;
4.1.8 Rights with respect to automated decision making and profiling.<br><br>
4.2 If you have any cause for complaint about Our use of your personal
data, please contact Us using the details provided in section 14 and
We will do Our best to solve the problem for you. If We are unable to
help, you also have the right to lodge a complaint with the UK’s supervisory
authority, the Information Commissioner’s Office.
4.3 For further information about your rights, please contact the Information
Commissioner’s Office or your local Citizens Advice Bureau.
 <h6><b>5. What Data Do We Collect?</b></h6> <br>
 Depending upon your use of Our Site, we may collect some or all of the
 following personal and non-personal data (please also see section 13 on
 Our use of Cookies and similar technologies):<br>&nbsp;&nbsp;
5.1 name<br>&nbsp;&nbsp;
5.2 business/company name<br>&nbsp;&nbsp;
5.3 email addresses and telephone number<br>&nbsp;&nbsp;
5.4 address, postcode<br>&nbsp;&nbsp;
5.5 credit / debit card numbers<br>&nbsp;&nbsp;
5.6 IP address<br>&nbsp;&nbsp;
5.7 web browser type and version<br>&nbsp;&nbsp;
5.8 operating system<br><br>
<h6><b>6. How Do We Use Your Data?</b></h6> <br>&nbsp;
6.1 All personal data is processed and stored securely, for no longer
than is necessary in light of the reason(s) for which it was first
collected. We will comply with Our obligations and safeguard your
rights &nbsp;&nbsp;&nbsp; under the GDPR at all times. For more
details on security see section 7, below.<br>&nbsp;
6.2 Our use of your personal data will always have a lawful basis,
either because it is necessary for Our performance of a contract with
you, because you have consented to Our use of your personal data
(e.g. &nbsp;&nbsp; by subscribing to emails), or because it is in
Our legitimate interests. Specifically, we may use your data for the
following purposes:<br>&nbsp;&nbsp;&nbsp;&nbsp;
6.2.1 Providing and managing your Account;<br>&nbsp;&nbsp;&nbsp;&nbsp;
6.2.2 Providing and managing your access to Our Site;<br>&nbsp;&nbsp;&nbsp;&nbsp;
6.2.3 Personalising and tailoring your experience on Our Site;<br>&nbsp;&nbsp;&nbsp;&nbsp;
6.2.4 Supplying Our products and services to you (please note that
We require your personal data in order to enter into a contract with you);
<br>&nbsp;&nbsp;&nbsp;&nbsp;
6.2.5 Personalising and tailoring Our products and services for you;<br>&nbsp;&nbsp;&nbsp;&nbsp;
6.2.6 Replying to emails from you;<br>&nbsp;&nbsp;&nbsp;&nbsp;
6.2.7 Supplying you with emails that you have opted into (you may
unsubscribe or opt-out at any time by selecting the unsubscribe
button in the e-mails;<br>&nbsp;&nbsp;&nbsp;&nbsp;
6.2.8 Market research;<br>&nbsp;&nbsp;&nbsp;&nbsp;
6.2.9 Analysing your use of Our Site and gathering feedback to
enable Us to continually improve Our Site and your user experience;<br>
6.3 With your permission and/or where permitted by law, We may
also use your data for marketing purposes which may include contacting
 you by email and or telephone and or text message and or post with
 &nbsp;&nbsp;&nbsp;&nbsp; information, news and offers on Our products
 and services. We will not, however, send you any unsolicited marketing
 or spam and will take all reasonable steps to ensure that We fully
 protect your rights &nbsp;&nbsp;&nbsp;&nbsp; and comply with Our
 obligations under the GDPR and the Privacy and Electronic Communications
 (EC Directive) Regulations 2003.<br>
6.4 Third parties whose content appears on Our Site may use third party
Cookies, as detailed below in section 13. Please refer to section 13 for
more information on controlling Cookies. Please note that We &nbsp;&nbsp;&nbsp;&nbsp;
do not control the activities of such third parties, nor the data they
collect and use and advise you to check the privacy policies of any such third parties.<br>
6.5 You have the right to withdraw your consent to Us using your
personal data at any time, and to request that We delete it.<br>
6.6 We do not keep your personal data for any longer than is
necessary in light of the reason(s) for which it was first collected.
Data will therefore be retained for the following periods (or its
retention will be &nbsp;&nbsp;&nbsp;&nbsp; determined on the following bases):
<br>&nbsp;&nbsp;&nbsp;&nbsp;
6.6.1 It is intended to maintain your personal data as long as you
remain a person with legitimate interest in our products and services,
this will be reviewed regularly;<br><br>
<h6><b>7. How and Where Do We Store Your Data?</b></h6> <br>&nbsp;
7.1 We only keep your personal data for as long as We need to in
order to use it as described above in section 6, and/or for as
long as We have your permission to keep it.<br>&nbsp;
7.2 Your data will only be stored within the European Economic
Area (“the EEA”) (The EEA consists of all EU member states, plus
Norway, Iceland, and Liechtenstein).<br>&nbsp;
7.3 Data security is very important to Us, and to protect your
data We have taken suitable measures to safeguard and secure
data collected through Our Site.<br>&nbsp;
7.4 Steps We take to secure and protect your data include: <br>&nbsp;
7.4.1 By working closely with our strategic partners Amazon,
Hubspot, Streamsend & Dropbox.<br><br>
<h6><b>8. Do We Share Your Data?</b></h6> <br>&nbsp;
8.1 We may share your data with other companies for Sales, Marketing, Support. <br>&nbsp;
8.2 We may sometimes contract with third parties to supply
products and services to you on Our behalf. These may include
payment processing, delivery of goods, search engine facilities,
advertising, and marketing. In some cases, the third parties may
require access to some or all of your data. Where any of your
data is required for such a purpose, We will take all reasonable
steps to ensure that your data will be handled safely, securely,
and in accordance with your rights, Our obligations, and the
obligations of the third party under the law.<br>&nbsp;
8.3 We may compile statistics about the use of Our Site including
data on traffic, usage patterns, user numbers, sales, and other
information. All such data will be anonymised and will not include
any personally identifying data, or any anonymised data that can be
combined with other data and used to identify you. We may from time
to time share such data with third parties such as prospective investors,
affiliates, partners, and advertisers. Data will only be shared and used
within the bounds of the law.<br>&nbsp;
8.4 The third party data processors used by Us and listed below are
located outside of the European Economic Area (“the EEA”) (The EEA consists
of all EU member states, plus Norway, Iceland, and Liechtenstein).
Where We transfer any personal data outside the EEA, We will take all
reasonable steps to ensure that your data is treated as safely and
securely as it would be within the UK and under the Data Protection
Act 1998 or GDPR including:<br>&nbsp;
<b>Amazon AWS, Hubspot, Streamsend, Dropbox</b><br>&nbsp;&nbsp;&nbsp;&nbsp;
8.4.1 Partner Privacy Polices<br>&nbsp;
8.5 In certain circumstances, We may be legally required to share
certain data held by Us, which may include your personal data, for
example, where We are involved in legal proceedings, where We are
complying with legal requirements, a court order, or a governmental authority.<br><br>
<h6><b>9.What Happens If Our Business Changes Hands?</b></h6> <br>&nbsp;
9.1 We may, from time to time, expand or reduce Our business and
this may involve the sale and/or the transfer of control of all
or part of Our business. Any personal data that you have provided
will, where it is relevant to any part of Our business that is being
transferred, be transferred along with that part and the new owner or
newly controlling party will, under the terms of this Privacy Policy,
be permitted to use that data only for the same purposes for which it
was originally collected by Us.<br>&nbsp;
9.2 In the event that any of your data is to be transferred in such a
manner, you will not be contacted in advance and informed of the changes.
When contacted you will, however, be given the choice to have your data
deleted or withheld from the new owner or controller.<br><br>
<h6><b>10. How Can You Control Your Data?</b></h6> <br>&nbsp;
10.1 When you submit personal data via Our Site, you may be given
options to restrict Our use of your data. In particular, We aim to
give you strong controls on Our use of your data for direct marketing
purposes (including the ability to opt-out of receiving emails from
Us which you may do by unsubscribing using the links provided in Our
emails and at the point of providing your details and by managing your Account).<br>&nbsp;
10.2 You may also wish to sign up to one or more of the preference
services operating in the UK: The Telephone Preference Service
(“the TPS”), the Corporate Telephone Preference Service (“the CTPS”),
and the Mailing Preference Service (“the MPS”). These may help to
prevent you receiving unsolicited marketing. Please note, however,
that these services will not prevent you from receiving marketing
communications that you have consented to receiving.<br><br>
<h6><b>11. Your Right to Withhold Information</b></h6> <br>&nbsp;
11.1 You may access certain areas of Our Site without providing any
data at all. However, to use all features and functions available on
Our Site you may be required to submit or allow for the collection of
certain data.<br>&nbsp;
11.2 You may restrict Our use of Cookies. For more information,
see section 13.<br><br>
<h6><b>12. How Can You Access Your Data?</b></h6> <br>
You have the right to ask for a copy of any of your personal
data held by Us (where such data is held). Under the GDPR, no
fee is payable and We will provide any and all information in
response to your request free of charge. Please contact Us for
more details at info@facitdatasystems.com, or using the contact
details below in section 14. <br><br>
<h6><b>13. Our Use of Cookies</b></h6> <br>&nbsp;
13.1 Our Site may place and access certain first party Cookies
on your computer or device. First party Cookies are those placed
directly by Us and are used only by Us. We use Cookies to facilitate
and improve your experience of Our Site and to provide and improve
Our products and services. We have carefully chosen these Cookies
and have taken steps to ensure that your privacy and personal data
is protected and respected at all times.<br>&nbsp;
13.2 By using Our Site you may also receive certain third party
Cookies on your computer or device. Third party Cookies are those
placed by websites, services, and/or parties other than Us. Third
party Cookies are used on Our Site for analytics. For more details,
please refer to section 6, above, and to section 13.6 below. These
Cookies are not integral to the functioning of Our Site and your
use and experience of Our Site will not be impaired by refusing
consent to them.<br>&nbsp;
13.3 All Cookies used by and on Our Site are used in accordance
with current Cookie Law.<br>&nbsp;
13.4 Before Cookies are placed on your computer or device, you
will be shown a popup requesting your consent to set those
Cookies. By giving your consent to the placing of Cookies you
are enabling Us to provide the best possible experience and
service to you. You may, if you wish, deny consent to the
placing of Cookies; however certain features of Our Site may
not function fully or as intended. You will be given the
opportunity to allow only first party Cookies and block third party Cookies.<br>&nbsp;
13.5 Certain features of Our Site depend on Cookies to
function. Cookie Law deems these Cookies to be “strictly necessary”.
These Cookies are shown below in section 13.6. Your consent will not
be sought to place these Cookies, but it is still important that you
are aware of them. You may still block these Cookies by changing your
internet browser’s settings as detailed below in section 13.10, but
please be aware that Our Site may not work properly if you do so.
We have taken great care to ensure that your privacy is not at
risk by allowing them.<br>&nbsp;
13.6 No first party Cookies may be placed on your computer or
device and the following third party Cookies may be placed on
your computer or device:<br><br>
    <table border="1px" width="100%">
      <tr>
        <td width="20%"><b>Name of Cookie</b></td>
        <td><b>Provider</b></td>
        <td><b>Purpose</b></td>
      </tr>
      <tr>
        <td>_ga</td>
        <td>Google</td>
        <td>Used to distinguish users.</td>
      </tr>
      <tr>
        <td>_gid</td>
        <td>Google</td>
        <td>Used to distinguish users.</td>
      </tr>
      <tr>
        <td>_gat</td>
        <td>Google</td>
        <td>Used to throttle request rate. If Google Analytics is
          deployed via Google Tag Manager, this cookie will be named _dc_gtm_
        </td>
      </tr>
      <tr>
        <td>AMP_TOKEN</td>
        <td>Google</td>
        <td>Contains a token that can be used to retrieve a Client
          ID from AMP Client ID service. Other possible values
          indicate opt-out, inflight request or an error retrieving
          a Client ID from AMP Client ID service.
        </td>
      </tr>
      <tr>
        <td>_gac_</td>
        <td>Google</td>
        <td>Contains campaign related information for the user.
          If you have linked your Google Analytics and AdWords
          accounts, AdWords website conversion tags will read this
          cookie unless you opt-out.
        </td>
      </tr>
    </table><br>&nbsp;
    13.7 Our Site uses analytics services provided by Google Analytics.
    Website analytics refers to a set of tools used to collect and
    analyse anonymous usage information, enabling Us to better
    understand how Our Site is used. This, in turn, enables Us to
    improve Our Site and the products and services offered
    through it. You do not have to allow Us to use these Cookies,
    however whilst Our use of them does not pose any risk to your
    privacy or your safe use of Our Site, it does enable Us to
    continually improve Our Site, making it a better and more
    useful experience for you.<br>&nbsp;
13.8 The analytics service(s) used by Our Site use(s) Cookies
to gather the required information.<br>&nbsp;
13.9 The analytics service(s) used by Our Site use(s) the
following Cookies:<br><br>
<table border="1px" width="100%">
  <tr>
    <td width="20%"><b>Name of Cookie</b></td>
    <td><b>First/Third Party</b></td>
    <td><b>Provider</b></td>
    <td><b>Purpose</b></td>
  </tr>
  <tr>
    <td>_ga</td>
    <td>Thrid</td>
    <td>Google</td>
    <td>Used to distinguish users.</td>
  </tr>
  <tr>
    <td>_gid</td>
    <td>Thrid</td>
    <td>Google</td>
    <td>Used to distinguish users.</td>
  </tr>
  <tr>
    <td>_gat</td>
    <td>Thrid</td>
    <td>Google</td>
    <td>Used to throttle request rate. If Google Analytics is
      deployed via Google Tag Manager, this cookie will be named _dc_gtm_.
    </td>
  </tr>
  <tr>
    <td>AMP_TOKEN</td>
    <td>Thrid</td>
    <td>Google</td>
    <td>Contains a token that can be used to retrieve a Client
      ID from AMP Client ID service. Other possible values
      indicate opt-out, inflight request or an error retrieving
      a Client ID from AMP Client ID service.
    </td>
  </tr>
  <tr>
    <td>_gac_</td>
    <td>Thrid</td>
    <td>Google</td>
    <td>Contains campaign related information for the user.
      If you have linked your Google Analytics and AdWords
      accounts, AdWords website conversion tags will read
      this cookie unless you opt-out.</td>
    </tr>
  </table>
  <br>&nbsp;
  13.10 In addition to the controls that We provide, you can
  choose to enable or disable Cookies in your internet browser.
  Most internet browsers also enable you to choose whether you
  wish to disable all cookies or only third party Cookies. By
  default, most internet browsers accept Cookies but this can
  be changed. For further details, please consult the help
  menu in your internet browser or the documentation that
  came with your device.<br>&nbsp;
13.11 You can choose to delete Cookies on your computer or
device at any time, however you may lose any information that
enables you to access Our Site more quickly and efficiently
including, but not limited to, login and personalisation settings.<br>&nbsp;
13.12 Our Site may place and access certain first party Cookies
on your computer or device. First party Cookies are those
placed directly by Us and are used only by Us. We use Cookies
to facilitate and improve your experience of Our Site and to
 provide and improve Our products and services. By using Our
 Site you may also receive certain third party Cookies on your
 computer or device. Third party Cookies are those placed by
 websites, services, and/or parties other than Us. Third party
 Cookies are used on Our Site for analytics. In addition, Our
 Site uses analytics services provided by Google Analytics,
 which also use Cookies. Website analytics refers to a set of
 tools used to collect and analyse usage statistics, enabling
 Us to better understand how people use Our Site.<br><br>
 <h6><b>14. Contacting Us</b></h6><br>
 If you have any questions about Our Site or this Privacy Policy,
 please contact Us by email at info@facitdatasystems.com by
 telephone on 03700 610 498, or by post at Technology Centre,
 Whittington Hall, Whittington road, Worcester, W5 2ZW.
 Please ensure that your query is clear, particularly
 if it is a request for information about the data We hold
 about you (as under section 12, above).<br><br>
 <h6><b>15. Changes to Our Privacy Policy</b></h6><br>
 We may change this Privacy Policy from time to time
 (for example, if the law changes). Any changes will be
 immediately posted on Our Site and you will be deemed to
 have accepted the terms of the Privacy Policy on your first
 use of Our Site following the alterations. We recommend that
 you check this page regularly to keep up-to-date.<br><br>
 <h6><b>16. Software Agreement</b></h6><br>
 Please <a target="_blank" href="https://identitycloak.facitdatasystems.com/api/Containers/idcloakdownloads/download/Facit%20Identity%20Cloak%20-%20Software%20Licence%20Agreement_Web.pdf">click here</a> to download our software agreement.<br><br><br><br>
    </p>
    </div>
</div>
</div>
</div>
  </div>
</template>

<script>
import FacitHeader from '@/components/header';

export default {
  name: 'privacy',
  components: { FacitHeader },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
.main-nav {
  background-color: #2c3e50 !important;
  height: 90px;
}
.main-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  margin: auto;
}

.login-div {
  background-color: white;
  width: 100%;
  height: 260px;
}
.logo {
  margin-top: 20px;
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/termsConditions.vue